const NintendoConsoleLinks = [
    {
        name: 'Nintendo Entertainment System (NES)',
        url: 'nes'
    },
    {
        name: 'Super Nintendo (SNES)',
        url: 'snes'
    },
    {
        name: 'Game Boy',
        url: 'game-boy'
    },
    // {
    //     name: 'Nintendo 64',
    //     url: 'nintendo-64'
    // },
];

module.exports = {NintendoConsoleLinks};